import { render, staticRenderFns } from "./FeedBack.vue?vue&type=template&id=3c313da2&scoped=true&"
import script from "./FeedBack.vue?vue&type=script&lang=js&"
export * from "./FeedBack.vue?vue&type=script&lang=js&"
import style0 from "./FeedBack.vue?vue&type=style&index=0&id=3c313da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c313da2",
  null
  
)

export default component.exports